/* eslint-disable @nx/enforce-module-boundaries */
import { IBookMarkDetailResponse } from '@intigral/domain/lib/entity/interface/iBookmark';
import _ from 'lodash';
import h from '../../helpers/common';
import channelsUtil from '../../helpers/channelsUtil';
import { log } from '@intigral/utils/lib/logger';
import c from '../../config/constants';
export const transformBookmarksResponse = (data: IBookMarkDetailResponse['data']) => {
    const bookmarksList = data?.entries ? data.entries : [];
    const transformedBookmarksList: any = [];
    (bookmarksList || []).map((bookmark) => {
        const bookmarkListing = bookmark.listings;
        const startTime = bookmarkListing && bookmarkListing?.length > 0 && bookmarkListing[0].startTime;
        const endTime = bookmarkListing && bookmarkListing?.length > 0 && bookmarkListing[0].endTime;
        const duration =
            bookmark.programType === 'VOD'
                ? bookmark.duration
                : Math.round(new Date(endTime || '').getTime() / 1000) -
                  Math.round(new Date(startTime || '').getTime() / 1000);

        transformedBookmarksList.push({
            Id: bookmark.id,
            guid: bookmark.guid ? bookmark.guid : '',
            description: h.getLang() === 'en' ? bookmark.description : bookmark?.descriptionLocalized?.['ar'] ?? '',
            programType: bookmark.programType,
            subType: bookmark.subType,
            tags: bookmark.subType === 'episode' ? bookmark.seriesTags : bookmark.tags,
            text:
                bookmark.subType === 'episode' && bookmark.programType !== 'LINEAR'
                    ? h.getLang() === 'en'
                        ? bookmark.seriesTitle + ': ' + bookmark.title
                        : bookmark.seriesLocalizedTitle?.['ar'] + ': ' + bookmark.titleLocalized?.['ar']
                    : h.getLang() === 'en'
                    ? bookmark.title
                    : bookmark.titleLocalized?.['ar'],
            textAr:
                bookmark.subType === 'episode' && bookmark.programType !== 'LINEAR'
                    ? bookmark.seriesLocalizedTitle?.['ar'] + ': ' + bookmark.titleLocalized?.['ar']
                    : bookmark.titleLocalized?.['ar'],
            textEn:
                bookmark.subType === 'episode' && bookmark.programType !== 'LINEAR'
                    ? bookmark.seriesTitle + ': ' + bookmark.title
                    : bookmark.title,
            image: bookmark.images && bookmark.images[0] ? bookmark.images[0].url : null,
            image_landscape: bookmark.images && bookmark.images[0] ? bookmark.images[0].url : null,
            year: bookmark.year,
            genre:
                (!!bookmark.tags &&
                    _.filter(bookmark.tags, (i: any) => i.scheme === 'Genre' && i.title).map((el: any) => el.title)) ||
                [],
            timeCode: bookmark.timeCode,
            duration: duration,
            percentage: (Math.ceil(Number(bookmark.timeCode)) * 100) / Math.ceil(Number(duration)) + '%',
            percentageNumber: (Math.ceil(Number(bookmark.timeCode)) * 100) / Math.ceil(Number(duration)),
            seasonNumber: bookmark.seasonNumber,
            seriesId: bookmark.seriesId,
            listingId: bookmarkListing && bookmarkListing.length > 0 ? bookmarkListing[0].id : null,
            stationId: bookmarkListing && bookmarkListing.length > 0 ? bookmarkListing[0].stationId : null,
            startTime: bookmarkListing && bookmarkListing.length > 0 ? bookmarkListing[0].startTime : null,
            endTime: bookmarkListing && bookmarkListing.length > 0 ? bookmarkListing[0].endTime : null,
            seriesTitle: h.getLang() === 'en' ? bookmark.seriesTitle : bookmark.seriesLocalizedTitle?.['ar'],
            ratings: h.getGenreRating(bookmark.parentalRatings),
            seriesGUID:
                bookmark.subType === 'episode' && bookmark.seriesId !== null
                    ? (bookmark.seriesId || '').split('/').pop()
                    : null,
            episodeNumber: bookmark.episodeNumber,
        });
    });
    return transformedBookmarksList;
};
export const transformMiniEPGItem = (item, channel) => {
    return {
        Id: item.paId,
        guid: item.listingGuid || '',
        name: item.title,
        text: h.getLang() === 'en' ? item.title : item.localizedTitle.ar,
        description: h.getLang() === 'en' ? item.description : item.localizedDescription.ar,
        image: (item.images[0] || {}).imageUrl || '',
        ratings: h.getGenreRating(item.ratings) || '',
        dateTime: item.startTime && channelsUtil.formatPastDuration(new Date(item.startTime).getTime()),
        startTime: item.startTime,
        endTime: item.endTime,
        stationId: channel.stationURL || '',
        category: 'LINEAR',
        channelTitle: channel.channelTitle,
        channelNumber: channel.channelNumber,
        ...(channel.category &&
            Array.isArray(channel.category) &&
            channel.category[0] && {
                channelCategory: channel.category[0],
            }),
        channelId: channel.channelID,
        channelImage:
            (_.find(channel.channelImages, (img) => img.id === 'colour_264x264') || channel.channelImages[0])?.url ||
            '',
        listingId: item.listingId,
        listingGuid: item.listingGuid,
        programType: item.programType,
    };
};

export const transformResponseVodAndRewindList = (responseData) => {
    // Watchlist - carousel nad watchlist page  will show TVODs with active contents only and will show all items for other vods.
    const filteredContents = responseData?.entries ?? [];
    return filteredContents.map(function (vod) {
        return vod.category === 'VOD' ? transformVodItem(vod) : transformRewindItem(vod);
    }, this);
};

export const transformVodItem = (vod) => {
    const providers = h.getProviders();
    return {
        Id: vod.id,
        guid: vod.guid || '',
        name: vod.title,
        text: h.getLang() === 'en' ? vod.title : vod.titleLocalized.ar,
        description: h.getLang() === 'en' ? vod.description : vod.descriptionLocalized.ar,
        image: (_.find(vod.images, (i) => i.type === 'poster') || {}).url || '',
        image_landscape: (_.find(vod.images, (i) => i.type === 'cover') || {}).url || '',
        year: vod.year,
        tags: vod.programTags,
        genre:
            (!!vod.programTags &&
                _.filter(vod.programTags, (i) => i.scheme === 'Genre' && i.title).map((i) => i?.title)) ||
            [],
        provider:
            (!!vod.programTags &&
                _.filter(vod.programTags, (i) => i.scheme === 'Categories' && i.title in providers).map(
                    (i) => i.title
                )) ||
            [],
        categories:
            (!!vod.programTags &&
                _.filter(vod.programTags, (i) => i.scheme === 'Categories' && !(i.title in providers)).map(
                    (i) => i.title
                )) ||
            [],
        ratings: h.getGenreRating(vod.parentalRatings) || '',
        episodeNumber: vod.episodeNumber,
        seasonNumber: vod.seasonNumber,
        duration: vod.duration,
        category: 'VOD',
        programType: vod.programType,
        purchaseStatus: vod.purchaseStatus,
        productId: vod.productId,
        subscriptionGuids: vod.subscriptionGuids,
    };
};

export const transformRewindItem = (rewind) => {
    const listingObj = rewind.lastAirListing || (rewind.listings && rewind.listings[0]) || {};
    return {
        Id: rewind.id,
        guid: rewind.guid || listingObj.guid || '',
        name: rewind.title,
        text: h.getLang() === 'en' ? rewind.title : rewind.titleLocalized.ar,
        image: (_.find(rewind.images, (i) => i.type === 'cover') || {}).url || '',
        ratings: h.getGenreRating(rewind.parentalRatings || rewind.ratings) || '',
        dateTime: listingObj.startTime && channelsUtil.formatPastDuration(new Date(listingObj.startTime).getTime()),
        startTime: listingObj.startTime,
        recordingStartTime: listingObj?.recordingStartTime ?? listingObj.startTime,
        endTime: listingObj.endTime,
        stationId: listingObj.stationId || '',
        year: rewind.year || '',
        category: 'LINEAR',
        tags: rewind.programTags || [],
        genre:
            (!!rewind.programTags &&
                _.filter(rewind.programTags, (i) => i.scheme === 'Genre' && i.title).map((el) => el.title)) ||
            [],
        channelName: rewind.channelName,
        channelNumber: rewind.channelNumber,
        ...(rewind.category &&
            Array.isArray(rewind.category) &&
            rewind.category[0] && {
                channelCategory: rewind.category[0],
            }),
        channelId: rewind.channelId,
        listingId: listingObj.id || '',
        listings: rewind.listings || [],
        description: h.getLang() === 'en' ? rewind.description : rewind.descriptionLocalized['ar'],
        programType: 'Rewind',
        subscriptionGuids: rewind.subscriptionGuids,
    };
};

/**
 * Rewind Transform Response
 * @param data
 * @returns {[]}
 */
export const rewindDatatransform = (responseData, channels) => {
    const entries = responseData.entries || [];
    if (typeof entries !== 'undefined' && entries !== null && entries !== false) {
        return entries.map(function (vod) {
            if (vod.listings && vod.listings[0]) {
                for (const i in channels) {
                    if (vod.listings[0].stationId === channels[i].stationURL) {
                        vod.channelName = channels[i].channelTitle;
                        vod.channelNumber = channels[i].channelNumber;
                        vod.category = channels[i].category;
                    }
                }
            } else {
                vod.channelName = '';
                vod.channelNumber = '';
                vod.category = '';
            }
            return transformRewindItem(vod);
        }, this);
    }
    return null;
};

export const transformResponseJawwy = (data) => {
    const transformedPromotionList = [];
    const promotionList = data.promotions;
    const providers = h.getProviders();

    for (let cnt = 0; cnt < promotionList.length; ++cnt) {
        const transformedPromotion: any = {};
        const promotion = promotionList[cnt];
        transformedPromotion.Id = promotion.promotionId;
        transformedPromotion.orderId = promotion.orderId;

        transformedPromotion.promoType = promotion.promoType ? promotion.promoType : false;
        transformedPromotion.screenId = promotion.screenId ?? null;
        transformedPromotion.showPrice = promotion.showPrice;
        transformedPromotion.showText = promotion.showText;
        transformedPromotion.guid = promotion.guid ? promotion.guid : null;

        if (Object.prototype.hasOwnProperty.call(promotion, 'properties')) {
            const propety = promotion.properties?.[0] || {};
            transformedPromotion.price = propety.price;
            transformedPromotion.title = propety.title;
            transformedPromotion.year = propety.year;
            if (propety.media && Array.isArray(propety.media)) {
                transformedPromotion.media = propety.media.find((item) => {
                    return item.assetTypes.includes('Trailer');
                });
            }
            transformedPromotion.programType = propety.programType;
            transformedPromotion.currency = propety.currency;

            transformedPromotion.seriesId = propety.seriesId;
            transformedPromotion.seasonId = propety.seasonId;
            transformedPromotion.programAvailabilityId = propety.programAvailabilityId;
            transformedPromotion.seriesGuid = (propety.seriesGuid && propety.seriesGuid) || '';
            transformedPromotion.firstEpisodeId = (propety.firstEpisodeId && propety.firstEpisodeId) || '';
            transformedPromotion.noOfEpisodes = (propety.noOfEpisodes && propety.noOfEpisodes) || '';
            transformedPromotion.programDescription = (propety.programDescription && propety.programDescription) || '';
            transformedPromotion.episodeNumber = (propety.episodeNumber && propety.episodeNumber) || '';
            transformedPromotion.duration = (propety.duration && propety.duration) || '';
            transformedPromotion.seriesPaId = (propety.seriesPaId && propety.seriesPaId) || '';
            transformedPromotion.categories = (propety.categories && propety.categories) || '';
            transformedPromotion.isTvod = false;
            // transformedPromotion.subscriptionGuids = propety.subscriptionGuids || propety.subscriptionGuid || '';
            transformedPromotion.subscriptionGuids =
                propety?.subscriptionGuids ?? (propety?.subscriptionGuid ? [propety.subscriptionGuid] : []);

            if (transformedPromotion.categories && Array.isArray(transformedPromotion.categories)) {
                transformedPromotion.isTvod = h.isIncluded(propety.categories, 'TVOD');
                transformedPromotion.categories = propety.categories.filter(
                    (i) => (providers[i] || {}).mixpanel || ''
                )[0];
            }

            transformedPromotion.genre = (propety.genre && propety.genre) || '';
            transformedPromotion.programTitle = (propety.programTitle && propety.programTitle) || '';
            transformedPromotion.channelNumber = (propety.channelNumber && propety.channelNumber) || '';
            transformedPromotion.channelTitle = (propety.channelTitle && propety.channelTitle) || '';

            // if (promotion.promoType === 'SEASON')
            transformedPromotion.guid = promotion?.properties?.[0]?.guid || '';

            if (promotion.promoType === 'SEASON') {
                transformedPromotion.Id = propety.seriesPaId;
            } else if (['LIVESTREAM', 'CHANNEL'].includes(promotion.promoType)) {
                transformedPromotion.Id = propety.channelId;
            } else {
                transformedPromotion.Id = propety.programAvailabilityId;
            }
            const ratingArr = propety.rating && !Array.isArray(propety.rating) ? [propety.rating] : propety.rating;
            transformedPromotion.rating = h.getGenreRating(ratingArr);
            transformedPromotion.ratings = promotion.program
                ? h.getGenreRating(promotion?.program?.ratings) || ''
                : h.getGenreRating(propety?.ratings) || '';
            transformedPromotion.channelId = propety.channelId;
            transformedPromotion.stationId = propety.stationId;
            transformedPromotion.startTime = propety.startTime ? propety.startTime : '';
            transformedPromotion.endTime = propety.endTime ? propety.endTime : '';
            transformedPromotion.paId = propety.programAvailabilityId;
            transformedPromotion.seasonNumber = propety.seasonNumber;
        }

        if (Object.prototype.hasOwnProperty.call(promotion, 'images')) {
            transformedPromotion.images = promotion.images;
        }

        transformedPromotion._text = {};
        transformedPromotion.cmsDesc = {};
        transformedPromotion._text['en'] = '';
        transformedPromotion._text['ar'] = '';
        const text = Object.prototype.hasOwnProperty.call(promotion, 'localizedTexts')
            ? promotion.localizedTexts
            : null;
        if (Object.prototype.hasOwnProperty.call(promotion, 'localizedTexts')) {
            if (Object.prototype.hasOwnProperty.call(text, 'ar')) {
                transformedPromotion.textAr = text.ar[0];
                transformedPromotion._text['ar'] = text.ar[0];
                transformedPromotion.cmsDesc['ar'] = text?.descAr || '';
            }

            if (Object.prototype.hasOwnProperty.call(text, 'en')) {
                transformedPromotion.textEn = text.en[0];
                transformedPromotion._text['en'] = text.en[0];
                transformedPromotion.cmsDesc['en'] = text?.descEn || '';
            }
        }
        if (Object.prototype.hasOwnProperty.call(promotion, 'images')) {
            const BannerEn = promotion.images.filter((image) => {
                return image && image.url && image.url.indexOf('webcp_en') !== -1;
            });
            const BannerAr = promotion.images.filter((image) => {
                return image && image.url && image.url.indexOf('webcp_ar') !== -1;
            });
            const LogoEn = promotion.images.filter((image) => {
                return image && image.url && image.url.indexOf('webcp_logo_en') !== -1;
            });
            const LogoAr = promotion.images.filter((image) => {
                return image && image.url && image.url.indexOf('webcp_logo_ar') !== -1;
            });

            transformedPromotion.image =
                h.getLang() === c.LANG_EN
                    ? Array.isArray(BannerEn) && BannerEn.length
                        ? BannerEn?.[0]?.url
                        : ''
                    : Array.isArray(BannerAr) && BannerAr.length
                    ? BannerAr?.[0]?.url
                    : '';
            transformedPromotion.logo =
                h.getLang() === c.LANG_EN
                    ? Array.isArray(LogoEn) && LogoEn.length
                        ? LogoEn?.[0]?.url
                        : ''
                    : Array.isArray(LogoAr) && LogoAr.length
                    ? LogoAr?.[0]?.url
                    : '';
        }
        transformedPromotion.text =
            h.getLang() === c.LANG_EN ? (text?.en?.length ? text.en[0] : '') : text?.ar?.length ? text.ar[0] : '';
        transformedPromotion.getText = function (lang) {
            return transformedPromotion._text[lang];
        };
        transformedPromotion.liveStream = promotion?.program;

        /* if (transformedPromotion.promoType === "SERIES") {*/
        transformedPromotionList.push(transformedPromotion);
        /*}*/
    }
    return transformedPromotionList;
};
